// extracted by mini-css-extract-plugin
module.exports = {"ForumPosts__list":"hz_a pz_mz pz_mu pz_sz","ForumPosts__contest":"hz_b pz_ha","ForumPosts__counselling":"hz_c"};